import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

export const useAuthenticationMethods = (isAnyAdminViewingOthers: boolean, userId: string) => {
    const managementQuery = useQuery({
        ...queries.mfa.managementAuthenticationMethods(userId),
        enabled: isAnyAdminViewingOthers,
    });

    const userQuery = useQuery({
        ...queries.mfa.authenticationMethods,
        enabled: !isAnyAdminViewingOthers,
    });

    return isAnyAdminViewingOthers ? managementQuery : userQuery;
};
